<template>
  <div class="paramsInput">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">参数录入</div>
        <div class="select-container">
           <div class="select-container-box">
             <span>基地&nbsp;&nbsp;</span>
              <el-select v-model="fishBaseId"  filterable placeholder="请选择"  size="small" @change="changeBase">
                <el-option
                  v-for="(item, index) in baseList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
            <div class="select-container-box">
              <span>时间&nbsp;&nbsp;</span>
              <el-date-picker
                size="small"
                v-model="start"
                type="date"
                :clearable="false"
                placeholder="开始日期"
                @change="changeTime(0)"
                value-format="yyyy-MM-dd"
                :picker-options="pickerTimeOptions">
              </el-date-picker>
            </div>
            <div class="select-container-box" style="padding:0 5px">
              <span>至</span>
            </div>
            <div class="select-container-box" style="padding:0 1px">
              <el-date-picker
                size="small"
                v-model="end"
                type="date"
                :clearable="false"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="changeTime(1)"
                :picker-options="pickerTimeOptions">
              </el-date-picker>
            </div>
          <div class="select-container-box"  v-if="canEditAll=true">
            <el-button size="small" type="info" plain @click="goSearch()" class="query" >查询</el-button>
            <el-button size="small" type="info" plain @click="goAdd" class="add" v-if="edit">增加</el-button>
          </div>
        
        </div>
      </div>
    
      <div class="table-container">
        <el-table
         :data="wQParameterList.list"
          @row-dblclick="dataBackFillGoods"
          style="width:100%" 
          size="medium" 
          :default-sort="{prop: 'date', order: 'descending'}">
           <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
          <el-table-column
            prop="dataTime"
            label="时间" 
            :formatter="formatter" 
            width="200"
            align="center">
          </el-table-column>
          <el-table-column 
            prop="pondName" 
            label="塘口" 
            width="200"
            show-overflow-tooltip 
            align="center">
          </el-table-column>
          <el-table-column
            prop="do" 
            label="溶解氧(mg/L)" 
            align="center"
            width="140"
            show-overflow-tooltip 
          >
          </el-table-column>
          <el-table-column 
          prop="ph" 
          label="PH" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="temp" 
          label="水温(℃)" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="electroRedox" 
          align="center" 
          label="氧化电还原"
          width="140"
          show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="nitrite"
            label="亚盐(mg/L)"
            align="center"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ammoniaNitrogen"
            label="氨氮(mg/L)"
            align="center"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column 
            prop="ownerName" 
            align="center" 
            label="记录员"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作栏" align="center"  width="140">
            <template slot-scope="scope">
              <span @click="editData(scope.$index, scope.row)" class="content-edit" >{{edit?"编辑":"查看"}}</span>
              <span @click="delWQP(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
      <!-- 水质参数弹窗 -->
      <div v-if="dialogFormVisible" :class="{edit:!edit}" class="role">
        <el-dialog :title="titleName"  :visible.sync="dialogFormVisible" width="766px"  >
          <!-- <div :class="{'content-form-container':true,'readonly':!isEdit}"> -->
          <el-form :model="baseForm" :rules="rules" ref="baseForm" class="baseForm" >
            <el-form-item label="所在基地" prop="fishBaseId"  :label-width="formLabelWidth">
              <el-select v-model="baseForm.fishBaseId" filterable :disabled="!edit" placeholder="请选择基地"  @change="baseChange">
                <el-option
                  v-for="(item, index) in baseLists"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在塘口" prop="pondId" :label-width="formLabelWidth">
              <el-select v-model="baseForm.pondId" filterable :disabled="!edit" placeholder="请选择塘口">
                <el-option
                  v-for="item in pondList"
                  :key="item.id" 
                  :label="item.value" 
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录入日期" prop="dataTime" :label-width="formLabelWidth">
                <el-date-picker
                  prefix-icon="el-icon-date"
                  v-model="baseForm.dataTime"
                  type="datetime"
                   :disabled="!edit"
                  value-format="yyyy-MM-dd HH:mm:ss" 
                  placeholder="请选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="溶解氧" prop="do" :label-width="formLabelWidth">
              <el-input 
                v-model.number="baseForm.do"  
                :maxlength="num11" 
                placeholder="请输入溶解氧"
                 :disabled="!edit"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
                >
                <i slot="suffix" style="font-style:normal">mg/L</i>
              </el-input>
            </el-form-item>
            <el-form-item label="PH" prop="ph" :label-width="formLabelWidth">
              <el-input 
                v-model.number="baseForm.ph"  
                :maxlength="num11" 
                 :disabled="!edit"
                placeholder="请输入PH"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
              >
              </el-input>
            </el-form-item>
            <el-form-item label="水温" prop="temp" :label-width="formLabelWidth">
              <el-input 
                v-model.number="baseForm.temp"  
                :maxlength="num11" 
                 :disabled="!edit"
                placeholder="请输入水温" 
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
                >
                <i slot="suffix" style="font-style:normal">℃</i>
              </el-input>
            </el-form-item>
            <el-form-item label="氧化电还原" prop="electroRedox" :label-width="formLabelWidth">
              <el-input 
                v-model.number="baseForm.electroRedox"  
                :maxlength="num11" 
                :disabled="!edit" 
                placeholder="请输入氧化电还原" 
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" 
                >
                <i slot="suffix" style="font-style:normal">mV</i>
              </el-input>
            </el-form-item>
            <el-form-item label="亚盐" prop="nitrite" :label-width="formLabelWidth">
              <el-input
                v-model.number="baseForm.nitrite"
                :maxlength="num11"
                :disabled="!edit"
                placeholder="请输入亚盐"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              >
                <i slot="suffix" style="font-style:normal">mg/L</i>
              </el-input>
            </el-form-item>
            <el-form-item label="氨氮" prop="ammoniaNitrogen" :label-width="formLabelWidth">
              <el-input
                v-model.number="baseForm.ammoniaNitrogen"
                :maxlength="num11"
                :disabled="!edit"
                placeholder="请输入氨氮"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              >
                <i slot="suffix" style="font-style:normal">mg/L</i>
              </el-input>
            </el-form-item>
            <div class="dialog-footer"  v-if="edit">
              <el-button @click="cancel('baseForm')">取 消</el-button>
              <el-button type="primary" @click="save('baseForm')" v-if="this.titleName === '添加参数录入'">保 存</el-button>
              <el-button type="primary" @click="editSave('baseForm')" v-if="this.titleName === '编辑参数录入'">保 存</el-button>
            </div>
          </el-form>
          <!-- </div> -->
        </el-dialog>
      </div>
   
    </div>
  </div>
</template>


<script>
import PageChange from "../../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../../store";
import { storage } from "../../../../service/storage";
import checkPermission from "../../../../service/checkPermission.js";
import {
  resolveFishBaseKeyFromList,
  fishBaseIdForQuery,
} from "@/common/resolveFishBaseSelection.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "paramsInput",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "82px",
      titleName: "",
      num20: 20,
      num11: 11,
      num30: 30,
      baseForm: {
        fishBaseId: "", //基地
        electroRedox: "", //氧化电还原
        temp: "", //水温
        do: "", //溶解氧
        ph: "", //ph
        nitrite: "",
        ammoniaNitrogen: "",
        dataTime: "",
        pondId: "" // 所在塘口
      },
      rules: {
        fishBaseId: [
          { required: true, message: "请先选择基地", trigger: "blur" }
        ],
        pondId: [{ required: true, message: "请先选择塘口", trigger: "blur" }],
        dataTime: [
          { required: true, message: "请先选择时间", trigger: "blur" }
        ],
        do: [
          {
            pattern: /^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "溶解氧范围为：-9999.00~9999.00"
          }
        ],
        ph: [
          {
            pattern: /^(([0-9]|1[0-3])(\.[0-9]{1,2})?|14)$/,
            message: "PH范围为：0.00-14"
          }
        ],
        temp: [
          {
            pattern: /^(\d{1,2}(\.\d{1,2})?|100)$/,
            message: "水温范围：0.00~100"
          }
        ],
        electroRedox: [
          {
            pattern: /^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "氧化电还原范围为：-9999.00~9999.00"
          }
        ],
        nitrite: [
          {
            pattern: /^$|^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "亚盐范围为：-9999.00~9999.00"
          }
        ],
        ammoniaNitrogen: [
          {
            pattern: /^$|^-?[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "氨氮范围为：-9999.00~9999.00"
          }
        ]
      },
      fishBaseId: "", //基地
      baseList: [], //查询-基地列表
      baseLists: [], //添加-基地列表
      pondList: [], //塘口列表
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      // list: [],
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      rowId: "" // 编辑的id
    };
  },
  methods: {
    ...mapActions(modules.waterQualityParameter, [
      "getWQParameterData",
      "delWQParameter",
      "addWQParameter",
      "getEditWQParameter",
      "updateWQParameter"
    ]),
    ...mapActions(modules.base, [
      "getAllBaseList" //基地信息
    ]),
    ...mapActions(modules.pond, [
      "getFishPond" //塘口
    ]),
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },

    //查询所有数据
    async goSearch(pageNum) {
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end
      };
      try {
        let result = await this.getWQParameterData(obj);
        this.pageInfo.totalPages = result.data.total;
      } catch (error) {
        this.$message.error(error.response.data);
      }
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.dataTime) {
        return false;
      }
      return this.$timeformat(row.dataTime);
    },
    // 添加--
    goAdd() {
      this.dialogFormVisible = true;
      this.titleName = "添加参数录入";
      this.baseForm = {
        electroRedox: "",
        temp: "",
        do: "",
        ph: "",
        nitrite: "",
        ammoniaNitrogen: "",
        dataTime: "",
        pondId: "",
        fishBaseId: ""
      };
      this.getAllBaseList().then(data => {
        this.baseLists = data;
        // 添加基地默认项与 记住选中基地
        let addBase = storage.get("base");
        let oldBases = this.baseLists.find(f => f.key == addBase);
        if (oldBases) {
          this.baseForm.fishBaseId = oldBases.key;
        } else {
          this.baseForm.fishBaseId = this.baseLists[0].key;
        }
      }); //基地
    },
    //取消
    cancel() {
      this.dialogFormVisible = false;
      this.baseForm = {
        electroRedox: "",
        temp: "",
        do: "",
        ph: "",
        nitrite: "",
        ammoniaNitrogen: "",
        dataTime: "",
        pondId: "",
        fishBaseId: ""
      };
    },
    //保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            electroRedox: this.baseForm.electroRedox,
            temp: this.baseForm.temp,
            do: this.baseForm.do,
            ph: this.baseForm.ph,
            nitrite: this.baseForm.nitrite,
            ammoniaNitrogen: this.baseForm.ammoniaNitrogen,
            dataTime: this.baseForm.dataTime,
            pondId: this.baseForm.pondId,
            fishBaseId: this.baseForm.fishBaseId
          };
          this.addWQParameter(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.goSearch();
                this.baseForm = {
                  electroRedox: "",
                  temp: "",
                  do: "",
                  ph: "",
                  nitrite: "",
                  ammoniaNitrogen: "",
                  dataTime: "",
                  pondId: "",
                  fishBaseId: ""
                };
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        } else {
          return false;
        }
      });
    },
    // 更新
    editSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.rowId,
            electroRedox: this.baseForm.electroRedox,
            temp: this.baseForm.temp,
            do: this.baseForm.do,
            ph: this.baseForm.ph,
            nitrite: this.baseForm.nitrite,
            ammoniaNitrogen: this.baseForm.ammoniaNitrogen,
            dataTime: this.baseForm.dataTime,
            pondId: this.baseForm.pondId,
            fishBaseId: this.baseForm.fishBaseId
          };
          this.updateWQParameter(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.goSearch();
                this.baseForm = {
                  electroRedox: "",
                  temp: "",
                  do: "",
                  ph: "",
                  nitrite: "",
                  ammoniaNitrogen: "",
                  dataTime: "",
                  pondId: "",
                  fishBaseId: ""
                };
                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
              // console.dir(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //改变基地数据
    baseChange(e, notShowTip) {
      storage.set("base", e);
      let selectedBase = this.baseList.find(f => f.key == e);
      if (!notShowTip && selectedBase && !selectedBase.notCleard) {
        this.$Alert.info({
          content: "当前选择的基地已经全部清塘，请选择其他基地",
          duration: 5000,
          status: "error"
        });
      }
      this.getFishPond(e)
        .then(data => {
          this.pondList = data;
          if (this.pondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下无塘口，请先添加塘口信息",
              duration: 5000,
              status: "error"
            });
          }
        })
        .catch(() => {});
      this.baseForm.pondId = null;
    },
    //获取当前行数据
    async editData(index, row) {
      if (this.edit) {
        this.titleName = "编辑参数录入";
      } else {
        this.titleName = "查看录入参数";
      }
      this.dialogFormVisible = true;

      let result = await this.getEditWQParameter(row.id);
      this.baseForm = result.data;
      this.rowId = row.id;
      this.pondList = await this.getFishPond(this.baseForm.fishBaseId);
    },
    //双击获取当前行数据
    async dataBackFillGoods(row, event) {
      this.dialogFormVisible = true;
      if (this.edit) {
        this.titleName = "编辑参数录入";
      } else {
        this.titleName = "查看录入参数";
      }
      let result = await this.getEditWQParameter(row.id);
      this.baseForm = result.data;
      this.rowId = row.id;
      this.pondList = await this.getFishPond(this.baseForm.fishBaseId);
    },
    //删除
    delWQP(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.rowId = row.id;
          await this.delWQParameter(this.rowId);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.goSearch(pageIndex);
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //存储选中基地
    changeBase(e) {
      storage.set("base", e);
    }
  },
  computed: {
    ...mapState(modules.waterQualityParameter, ["wQParameterList"])
  },
  async mounted() {
    this.baseList = await this.getAllBaseList(); //基地
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    if (this.fishBaseId != null) {
      this.getFishPond(this.fishBaseId)
        .then(data => {
          this.pondList = data;
          if (this.pondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下无塘口，请先添加塘口信息",
              duration: 5000,
              status: "error"
            });
          }
        })
        .catch(() => {});
    }

    this.goSearch();
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  }
};
</script>
<style lang="stylus" >
.role.isEdit 
  .el-input__inner,.el-select,.el-select__caret,.el-input__suffix-inner,.el-date-editor{
    pointer-events: none !important;
  }
.paramsInput
// 公共部分
  .el-dialog
    height:760px;
    position:absolute;
    left:50%;
    top:-50px;
    border-radius:6px;
    margin-left:-340px;
    .el-dialog__header 
      border-radius:6px 6px 0px 0px;
      padding: 16px 20px 16px;
      background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
      .el-dialog__title 
        color: #fff;
    .el-input
      width:500px;
    .el-input__inner
      width:500px;
      margin-left:10px;
    .el-form-item__content
      z-index:999999;
      line-height: 40px;
      position: relative;
      bottom:-10px;
      font-size: 14px;
    .el-form .el-form-item .el-form-item__label
      margin-top:6px;
      margin-left:65px;
      text-align:right;
    .ruleForm
      margin-left 0px
    .el-dialog__close 
      color:#fff
    .el-dialog__footer
      text-align left
      position relative
      bottom:12px;
      padding:0px 106px 0px
    .el-button--primary
      margin-left:20px
      background: #3389ff;
    .el-button
      width 100px
      height 40px
      margin-top:18px;
    .el-button--default
      margin-left:157px
    .el-form-item .el-form-item__label:before
      position: absolute;
      top: 2px;
      left: -13px;
      color: #fe3223;
    .el-form-item__error
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 2px;
      position: absolute;
      top: 100%;
      left: 74px;
    .el-select .el-tag 
      margin: 2px 0 2px 15px;
    .el-icon-date
      position: relative;
    .el-icon-date:before {
      content: "\E608";
      position: absolute;
      left: 13px;
      top: 3px;
    }
</style>
